<template>
  <div class="wrapper">
    <div v-show="text.length > 0">
      <div class="arc-indicator">
        <svg version="1.1"
          xmlns:svg="http://www.w3.org/2000/svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="-10 -10 110 110"
          preserveAspectRatio="xMidYMid"
          width="100%" height="100%">
          <circle cx="50" cy="50" r="32" stroke="#aaa"/>
          <path :d="getD()" :fill="color"/>
          <circle cx="50" cy="50" r="30" fill="#fff"/>
        </svg>
      </div>
      <span class="text-char-counter" :class="{'error': text.length >= maxTextLength}">{{text.length}}/{{ maxTextLength }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextLengthIndicator",
  components: {},
  props: {
    text: {type: String, default: '',},
    maxTextLength: {type: Number, default: 1,},
  },
  data() {
    return {
      radius: 50,
    };
  },
  computed: {
    color: function () {
      return this.value < 1.0 ? '#080' : '#800';
    },
    value: function() {
      return this.text.length / this.maxTextLength;
    },
  },
  methods: {
    getD: function () {
      let startAngle = 0;
      let endAngle = Math.min(1.0, this.value) * 360.0;
      const isCircle = endAngle - startAngle === 360;
      if (isCircle) {
        endAngle--;
      }
      const start = this.polarToCartesian(this.radius, startAngle);
      const end = this.polarToCartesian(this.radius, endAngle);
      const largeArcFlag = endAngle - startAngle <= 180 ? 0 : 1;
      const d = [ "M", start.x, start.y, "A", this.radius, this.radius, 0, largeArcFlag, 1, end.x, end.y ];
      if (isCircle) {
        d.push("Z");
      } else {
        d.push("L", this.radius, this.radius, "L", start.x, start.y, "Z");
      }
      return d.join(" ");
    },
    polarToCartesian: function(radius, angleInDegrees) {
      const radians = (angleInDegrees - 90) * Math.PI / 180;
      return {
        x: Math.round(this.radius + (this.radius * Math.cos(radians))),
        y: Math.round(this.radius + (this.radius * Math.sin(radians)))
      };
    },
  },
}
</script>

<style scoped>
.wrapper {
  display: block;
  height: 2rem;
}
.text-char-counter {
  font-size: 0.95rem;
}
.text-char-counter.error {
  color: #800;
}
.arc-indicator {
  vertical-align: middle;
  float: left;
  margin: 2px;
  width: 16px;
  height: 16px;
}
</style>
